import script from "./HeroFeaturesB.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroFeaturesB.vue?vue&type=script&setup=true&lang=js"

import "./HeroFeaturesB.vue?vue&type=style&index=0&id=d3bb7f84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3bb7f84"]])

export default __exports__